"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMonthlyVisitorReportMockData = exports.buildWeeklyVisitorReportMockData = void 0;
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const organization_facing_base_1 = require("./organization-facing-base");
const ONE_TIME_SUPPORTERS = [
    { name: "Alex Tremblay", volume: "$250.00" },
    { name: "Jordan Lee", volume: "$120.00" },
    { name: "Sam Okafor", volume: "$75.00" },
    { name: "Robin Dupont", volume: "$40.00" },
];
const RECURRENCE_MONTHLY_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Monthly",
    [locales_1.Locales.FR]: "Mensuel",
    [locales_1.Locales.ES]: "Mensual",
    [locales_1.Locales.DE]: "Monatlich",
});
const RECURRENCE_YEARLY_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Yearly",
    [locales_1.Locales.FR]: "Annuel",
    [locales_1.Locales.ES]: "Anual",
    [locales_1.Locales.DE]: "Jährlich",
});
const buildRecurringSupporters = (locale) => [
    { name: "Casey Nguyen", volume: `$50.00 ${(0, organization_facing_base_1.pickForLocale)(RECURRENCE_MONTHLY_BY_LOCALE, locale)}` },
    { name: "Morgan Silva", volume: `$300.00 ${(0, organization_facing_base_1.pickForLocale)(RECURRENCE_YEARLY_BY_LOCALE, locale)}` },
];
const WEEKLY_SUBJECT_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your weekly report for {orgName} is in!",
    [locales_1.Locales.FR]: "Votre rapport hebdomadaire pour {orgName} est arrivé !",
    [locales_1.Locales.ES]: "¡Tu informe semanal de {orgName} ya está aquí!",
    [locales_1.Locales.DE]: "Ihr Wochenbericht für {orgName} ist da!",
});
const MONTHLY_SUBJECT_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Your monthly report for {orgName} is in!",
    [locales_1.Locales.FR]: "Votre rapport mensuel pour {orgName} est arrivé !",
    [locales_1.Locales.ES]: "¡Tu informe mensual de {orgName} ya está aquí!",
    [locales_1.Locales.DE]: "Ihr Monatsbericht für {orgName} ist da!",
});
const buildWeeklyVisitorReportMockData = ({ locale = "en", subject, firstName = "John", orgName = "Bright Futures Foundation", reportDate = "1 January - 7 January", oneTimeSupporters = ONE_TIME_SUPPORTERS, recurringSupporters, moreOneTimeSupportersCount = 6, moreRecurringSupportersCount = 0, hasOrganizationPageBlock = false, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject ?? (0, organization_facing_base_1.pickForLocale)(WEEKLY_SUBJECT_BY_LOCALE, locale).replace("{orgName}", orgName)),
    firstName,
    orgName,
    reportDate,
    oneTimeSupporters,
    recurringSupporters: recurringSupporters ?? buildRecurringSupporters(locale),
    moreOneTimeSupportersCount,
    moreRecurringSupportersCount,
    dashboardLink: "https://www.zeffy.com/en-CA/o/dashboard",
    thankYouEmailLink: "https://www.zeffy.com/en-CA/o/emails/new",
    addUserLink: "https://www.zeffy.com/en-CA/o/settings?addUser=true",
    letUsKnowLink: "https://form.typeform.com/to/weekly-report-feedback",
    unsubscribeLink: "https://www.zeffy.com/en-CA/unsubscribe",
    ...(hasOrganizationPageBlock
        ? {
            organizationPageUrl: "https://www.zeffy.com/en-CA/o/bright-futures-foundation",
            organizationPageEditorLink: "https://www.zeffy.com/en-CA/o/organization-page/edit",
        }
        : {}),
});
exports.buildWeeklyVisitorReportMockData = buildWeeklyVisitorReportMockData;
const FORMS = [
    { title: "Annual Gala", volume: "$5,000.00" },
    { title: "Winter Coat Drive", volume: "$1,250.00" },
];
const buildMonthlyVisitorReportMockData = ({ locale = "en", subject, firstName = "John", orgName = "Bright Futures Foundation", reportDate = "January 2026", fundsRaised = "$6,250.00", payoutAmount = "$5,900.00", feesSaved = "$187.50", hasPayout = true, forms = FORMS, moreFormsCount = 3, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject ?? (0, organization_facing_base_1.pickForLocale)(MONTHLY_SUBJECT_BY_LOCALE, locale).replace("{orgName}", orgName)),
    firstName,
    orgName,
    reportDate,
    fundsRaised,
    payoutAmount,
    feesSaved,
    hasPayout,
    forms,
    moreFormsCount,
    paymentPageLink: "https://www.zeffy.com/en-CA/o/payments",
    addUserLink: "https://www.zeffy.com/en-CA/o/settings?addUser=true",
    letUsKnowLink: "https://form.typeform.com/to/monthly-report-feedback",
    unsubscribeLink: "https://www.zeffy.com/en-CA/unsubscribe",
});
exports.buildMonthlyVisitorReportMockData = buildMonthlyVisitorReportMockData;
